module.exports = __webpack_public_path__ + "img/avr.da5d0f1c.png";